// Services
import { HttpService } from "@mgs/ci2019-common/src/services/HttpService";
// Store
import { Store } from "#/store";
// Models
import { TypeSelectionResult } from "#/common/models/type_selection/TypeSelectionResult";
import { PitData } from "#/common/models/module/PitData";

export class PitService {
  private static _instance;

  public static get instance() {
    if (!this._instance) {
      this._instance = new PitService();
    }
    return this._instance;
  }

  private constructor() {}

  private readonly http: HttpService = HttpService.instance;

  public async getTypeSelection(
    klasse: number,
    filter: object,
    completeFilter: object
  ): Promise<TypeSelectionResult> {
    const response = await this.http.post<TypeSelectionResult>(
      Store.instance.ui.katalogApiUrl + `typeselection/${klasse}`,
      {
        filter: filter,
        completeFilter: completeFilter,
      }
    );
    return response.body!;
  }

  public async getSession(token: string): Promise<object> {
    const response = await this.http.get<object>(
      Store.instance.ui.katalogApiUrl + `session/${token}`
    );

    return response.body!;
  }

  public async getData(
    identifier: string,
    marketLangeageKey: string
  ): Promise<PitData> {
    const response = await this.http.get<PitData>(
      Store.instance.ui.pitApiUrl + `vehicle/${marketLangeageKey}/${identifier}`
    );

    return response.body!;
  }

  public async getMarketVersionData(): Promise<string[]> {
    const response = await this.http.get<{ items: string[] }>(
      Store.instance.ui.pitApiUrl + `market-version`
    );

    return response.body!.items;
  }
}
